import React, { Component } from 'react';
import {Tabs, Spin} from "antd";
import { connect } from 'dva';
import { stringify } from "qs";
import styles from './index.less';
import Container from "../../../../components/Container";
import router from "umi/router";
import homeImg from '../../../../assets/workFlow/home_bg.svg';

const AppList = (props)=> {
  const {appList = [], loading} = props;
  const handleGoDetail = (item)=> {
    const {appId} = item;
    router.push(`/workFlow/appList/detail?appId=${appId}`);
  };

  return (
    <Container breStates>
      <Spin spinning={loading}>
        <div className={styles.root}>
          {appList.length === 0 && (
            <div className='empty-container'>
              <div className='empty-img' />
              <div className='empty-text'>暂无数据</div>
            </div>
          )}
          {appList.map(item=>{
            const {appName='', appId, appImg } = item;
            return (
              <div
                key={appId}
                className='app-item'
                onClick={()=>handleGoDetail(item)}
              >
                <img
                  // src={appImg || homeImg}
                  src={appImg || 'https://wgwcdn.nbugs.com/b693544318444d46a882176c5712a3d8.png?x-oss-process=image/resize,w_500'}
                  alt=''
                />
                <div className='app-name'>{appName || '应用名称'}</div>
              </div>
            );
          })}
        </div>
      </Spin>
    </Container>
  );

};

export default connect(({workflowAppList, loading}) => {
  return {
    ...workflowAppList,
    loading: loading.effects['workflowAppList/fetchList'] || false,
  };
})(AppList);
